
<body>
<div class="container-fluid">
<div id="loader" *ngIf="loading"></div>

<div class="container-fluid" *ngIf="!loading"> 
<form  class="well form-horizontal" [formGroup]="userForm">
  <h2>Formulaire De Modification Des Données Utilisateurs</h2>
  <p>veuillez renseigner les champs obligatoires (*)</p>
  <table class="table table-striped">
    <tbody>
      <tr *ngIf="!showpassword">

        <td *ngIf="currentuser.role == 'superadmin'">
          <div class="form-group">
            <label class="col-md-4 control-label">Role</label>
            <div class="col-md-8 inputGroupContainer">
               <div class="input-group"><span class="input-group-addon"><i class="glyphicon glyphicon-user"></i></span>
                <select  class="input-field" placeholder="Entrer nature utilisateur" id="nature" formControlName="role" name="role" >
                  <option hidden [value]=""></option>
                  <option value=""></option>
                  <option value="superadmin">Super Admin</option>
                  <option value="adminbanque">Admin banque</option>
                  <option value="userbanque">Utilisateur banque</option>
                  <option value="basic">Utilisateur simple</option>
                </select>
                </div>
            </div>
         </div>
        </td>
        <td >
          <div class="form-group">
            <label class="col-md-4 control-label">Type utilisateur</label>
            <div class="col-md-8 inputGroupContainer">
               <div class="input-group"><span class="input-group-addon"><i class="glyphicon glyphicon-user"></i></span>
                <select  class="input-field"  placeholder="Entrer Votre Type Utilisateur"id="usertype" formControlName="usertype" name="usertype"
                [ngClass]="{ 'is-invalid': submitted && f.usertype.errors }" >
                  <option hidden >Entrer Votre Type Utilisateur</option>
                  <option value="Clientpor">Client porteur</option>
                  <option value="Clientcomm">Client commerçant</option>
                  <option value="Metier">Métier</option>
                  <option value="Agence">Agence</option>
                  <option value="comite arbitrage">Comite arbitrage</option>
                  <option disabled value="Candidat">Candidat</option>
                </select>
                </div>
            </div>
         </div>
        </td>
      </tr>
      <tr *ngIf="!showpassword">
        <td colspan="1">
          <div class="form-group">
            <label class="col-md-4 control-label">Nom Utilisateur</label>
            <div class="col-md-8 inputGroupContainer">
               <div class="input-group"><span class="input-group-addon"><i class="glyphicon glyphicon-home"></i></span>
                <input class="input-field" type="text" placeholder="Modifier Votre Nom" id="lastname" formControlName="lastname" name="lastname">
              </div>
            </div>
         </div>
        </td>
        <td colspan="1">
          <div class="form-group">
            <label class="col-md-4 control-label">Prénom Utilisateur</label>
            <div class="col-md-8 inputGroupContainer">
               <div class="input-group"><span class="input-group-addon"><i class="glyphicon glyphicon-home"></i></span>
                <input class="input-field" type="text" placeholder="Modifier Votre Prenom" id="firstname" formControlName="firstname">
              </div>
            </div>
         </div>
        </td>
      </tr>

      <tr *ngIf="!showpassword">
        <td colspan="2">
          <div class="form-group">
            <label class="col-md-4 control-label">Login</label>
            <div class="col-md-8 inputGroupContainer">
               <div class="input-group"><span class="input-group-addon"><i class="glyphicon glyphicon-envelope"></i></span>
                <input class="input-field" type="email" placeholder="Entrez Votre Email" id="email" formControlName="email" >
              </div>
            </div>
         </div>
        </td>
        <td>
          <div class="form-group">
            <label class="col-md-4 control-label">Numéro Mobile</label>
            <div class="col-md-8 inputGroupContainer">
               <div class="input-group"><span class="input-group-addon"><i class="glyphicon glyphicon-earphone"></i></span>
                <input class="input-field" type="text" placeholder="Entrez Votre Numéro Mobile" id="mobile" formControlName="mobile" >
              </div>
            </div>
         </div>
        </td>
      </tr>
      <tr *ngIf="!showpassword">
        <td>
          <div class="form-group">
            <label class="col-md-3 control-label">Numéro de compte:</label>
            <div class="col-md-9 inputGroupContainer">
               <div class="input-group"><span class="input-group-addon"><i class="glyphicon glyphicon-earphone"></i></span>
                <input class="input-field" type="text" placeholder="numéro de compte" id="selectfiscalimpot" (input)="controllength(this.userForm.controls['compte'],$event)"formControlName="compte">
              </div>
            </div>
         </div>
</td>
<!--<td>
  <div class="form-group">
    <label class="col-md-3 control-label">code banque:</label>
    <div class="col-md-9 inputGroupContainer">
       <div class="input-group"><span class="input-group-addon"><i class="glyphicon glyphicon-earphone"></i></span>
        <input class="input-field" type="text" placeholder="code banque" id="selectfiscalimpot" formControlName="banque">
      </div>
    </div>
 </div>
</td>--> 
<td>
  <div class="form-group">
    <label class="col-md-3 control-label">Numéro de carte:</label>
    <div class="col-md-9 inputGroupContainer">
       <div class="input-group"><span class="input-group-addon"><i class="glyphicon glyphicon-earphone"></i></span>
        <input class="input-field" type="text" placeholder="numéro de carte" id="selectfiscalimpot"(input)="controllength(this.userForm.controls['carte'],$event)" formControlName="carte">
      </div>
    </div>
 </div>
</td>
</tr>
<tr *ngIf="!showpassword">

  <td>
    <div class="form-group">
      <label class="col-md-3 control-label">Numéro d'affiliation:</label>
      <div class="col-md-9 inputGroupContainer">
         <div class="input-group"><span class="input-group-addon"><i class="glyphicon glyphicon-earphone"></i></span>
          <input class="input-field" type="text" placeholder="numéro affiliation" id="selectfiscalimpot" formControlName="affiliation">
        </div>
      </div>
   </div>
  </td>
  <td>
    <div class="form-group">
      <label class="col-md-3 control-label">Numéro terminal:</label>
      <div class="col-md-9 inputGroupContainer">
         <div class="input-group"><span class="input-group-addon"><i class="glyphicon glyphicon-earphone"></i></span>
          <input class="input-field" type="text" placeholder="numéro terminal" id="selectfiscalimpot" formControlName="terminal">
        </div>
      </div>
   </div>
  </td>
  <td>
    <div class="form-group">
      <label class="col-md-3 control-label">Indicatif Agence:</label>
      <div class="col-md-9 inputGroupContainer">
         <div class="input-group"><span class="input-group-addon"><i class="glyphicon glyphicon-earphone"></i></span>
          <input class="input-field" type="text" placeholder="indicatif agence" id="indicatifagence" formControlName="indicatifagence">
        </div>
      </div>
   </div>
  </td>
  </tr>
      <tr *ngIf="showpassword">
        <td colspan="2">
          <div class="form-group">
            <label class="col-md-4 control-label">Mot De Passe</label>
            <div class="col-md-8 inputGroupContainer">
               <div class="input-group"><span class="input-group-addon"><i class="glyphicon glyphicon-earphone"></i></span>
                <input class="input-field" type="password" placeholder="Modifier votre Mot de passe" id="password" formControlName="password">
              </div>
            </div>
         </div>
        </td>
        <td>
          <div class="form-group">
            <label class="col-md-4 control-label">Confirmer Mot De Passe</label>
            <div class="col-md-8 inputGroupContainer">
               <div class="input-group"><span class="input-group-addon"><i class="glyphicon glyphicon-earphone"></i></span>
                <input class="input-field" type="password" placeholder="confirmer votre Mot de passe" id="confirmpassword" formControlName="confirmpassword">
              </div>
            </div>
         </div>
        </td>
      </tr>
      <tr>
        <td colspan="3">
          <div class="form-group">
            <label class="col-md-4 control-label">Code Client</label>
            <div class="col-md-8 inputGroupContainer">
              <div class="input-group"><span class="input-group-addon"><i class="glyphicon glyphicon-home"></i></span>
                <input class="input-field" type="text" placeholder="code client" id="clientcode" formControlName="clientcode">
              </div>
            </div>
          </div>
        </td>
      </tr>
    </tbody>
 </table>
  <button class="btn btn-success" (click)="onSubmit()" id="input12">Envoyer Modification </button>
</form>
<p>{{ errormsg }}</p>
<div class="alert alert-success" *ngIf="isSuccessful">
  Modificaion effectuée avec succès!!
</div>
</div>
</div>
</body>